// @flow


import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import axios from "axios";

import "./index.css";
import "./c3jscustom.css";

import App from "./App.react";
import store from "./store";
import setupAxios from "./store/setupAxios";

setupAxios(axios, store);
const rootElement = document.getElementById("root");

if (rootElement) {
  createRoot(rootElement).render(
    <Provider store={store}>
      <App />
    </Provider>
  );
} else {
  throw new Error("Could not find root element to mount to!");
}
